import React from "react";
import l from "components/util/l";
import { Wizard } from "components/util/helpers/Wizard";

const TableControls = ({
  searchRef,
  activeCollection,
  flow,
  rows,
  columns,
  search,
  filters,
  multipleSelectedCells = [],
  showDelete,
  showSearch,
  showImport,
  showExport,
  showForm,
  showFilters,
  showDownloadZip,
  showPermissions,
  showManageCollections,
  isReadOnly,
  isSearchShown,
  setIsSingleImport,
  setIsImportModalShown,
  setIsExportModalShown,
  setIsFormModalShown,
  setIsSearchShown,
  setIsFilterModalShown,
  setSelectedCell,
  setMultipleSelectedCells,
  setIsCloneModalShown,
  onClickDownloadZip,
  onClickDeleteCollection,
  onClickClearData,
  onClickDeleteMultipleRows,
  onClickOpenCollectionEditModal,
  onClickOpenPermissionModal,
  updateSearch,
  refetchCollections
}) => {

  return (
    <div id="table-controls" className="d-flex align-items-center justify-content-end w-100 my-1">

      {!isReadOnly &&
        <Wizard
          flow={{ id: flow?.id }}
          mainProcessName={"CREATE_COLLECTION"}
          buttonClassName="mr-2 w-auto"
          buttonStyle={{ padding: "0.42rem 0.7rem", fontSize: "0.85rem" }}
          params={{
            collection_id: activeCollection?.id,
            name: `${activeCollection?.name}`,
            label: `${activeCollection?.uiSettings?.label}`,
            has_data: rows.reduce((acc, r) => {
              const hasData = Object.keys(r.data).filter(k => !k.startsWith("_internal_")).length > 0;
              if (hasData) acc.push(r.id);
              return acc;
            }, []).length > 0,
            modified: activeCollection?.settings?.modified
          }}
          onCompleted={() => {
            refetchCollections();
          }}
        />
      }

      {
        multipleSelectedCells.length > 0 &&
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-primary-white text-center mr-2 w-auto"
            type="button"
            id="dropdown-options"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {l("Acciones%GA005")} <i className="fas fa-sm fa-chevron-down ml-1"></i>
          </button>
          <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-options">
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                setMultipleSelectedCells([]);
              }}
            >
              <i className="fas fa-times dropdown-item-icon mr-2"></i>
              {l("Limpiar selección%CA110")}
            </button>
            {showDelete && (
              <button
                type="button"
                className="dropdown-item"
                onClick={() => {
                  onClickDeleteMultipleRows(multipleSelectedCells);
                }}
              >
                <i className="fas fa-trash dropdown-item-icon mr-2"></i>
                {l("Eliminar%GA001")}
              </button>
            )}
            {
              !isReadOnly && showManageCollections && multipleSelectedCells.length == rows.length && (
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={onClickClearData}>
                  <i className="fas fa-broom dropdown-item-icon mr-2"></i>
                  {l("Eliminar todos los datos%CA160")}
                </button>
              )
            }
          </div>
        </div>
      }

      {showForm && (
        <button
          type="button"
          className="btn btn-sm btn-lighter-white mr-4"
          onClick={() => setIsFormModalShown(true)}
        >
          <i className="fas fa-plus mr-2"></i>
          {l("Agregar dato%CA011")}
        </button>
      )}

      {
        showSearch &&
        <>
          {isSearchShown ? (
            <div id="table-search-input" className="animate__animated animate__fadeIn animate__faster">
              <div className="bg-white px-2 py-1 rounded mr-2">
                <i className="fas fa-search mr-3" />
                <input
                  ref={searchRef}
                  type="text"
                  className="border-0"
                  placeholder={l("Buscar%GA006")}
                  onFocus={() => setSelectedCell && setSelectedCell(null)}
                  onBlur={() => search.length === 0 && setIsSearchShown(false)}
                  defaultValue={search}
                  onChange={(e) => updateSearch(e.target.value)}
                />
                <i
                  role="button"
                  className="fas fa-times ml-3"
                  onClick={() => {
                    updateSearch("");
                    setIsSearchShown(false);
                  }}
                />
              </div>
            </div>
          ) : (
            <button
              id="table-search-button"
              type="button"
              className="btn btn-sm btn-lighter-white text-center"
              onClick={() => setIsSearchShown(true)}
            >
              <i className="fas fa-search"></i>
            </button>
          )}
        </>
      }


      <div id="table-control-buttons" className="d-flex align-items-center">

        {showFilters && filters.length > 0 && (
          <button
            id="table-filter-button"
            type="button"
            className={`btn btn-sm text-center ${filters.length > 0 ? "btn-primary text-white" : "btn-lighter-white"}`}
            onClick={() => setIsFilterModalShown(true)}
          >
            <i className={`fas fa-filter`}></i>
          </button>
        )}

        {/* Temp 250926
          function () {

            const hasSingleColumn = columns?.filter(c => !c.internal).length == 1;
            const hasSingleRow = rows?.length == 1;
            const rowKeys = Object.keys(rows?.[0]?.data || {});
            const hasOnlyInternalId = hasSingleRow && rowKeys.every(k => k.startsWith("_internal_"));

            if (showImport && hasSingleColumn && hasOnlyInternalId)

              return <button
                type="button"
                className="btn btn-sm btn-lighter-white text-center mr-2"
                onClick={() => {
                  setIsImportModalShown(true);
                  setIsSingleImport(true);
                }}
              >
                <i className="fas fa-file-import"></i>
              </button>;

          }()
        */}

        {
          (showImport || showExport || showPermissions || (!isReadOnly && showManageCollections)) && <>
            <button
              className="btn btn-sm btn-lighter-white text-center"
              type="button"
              id="dropdown-options"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-options">

              {showImport && (
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => setIsImportModalShown(true)}
                >
                  <i className="fas fa-file-import dropdown-item-icon mr-2"></i>
                  {l("Cargar excel%CA101")}
                </button>
              )}

              {showExport && (
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => setIsExportModalShown(true)}
                >
                  <i className="fas fa-download dropdown-item-icon mr-2"></i>
                  {l("Descargar datos%CA009")}
                </button>
              )}

              {
                !isReadOnly && showManageCollections && (
                  <div>
                    <hr className="my-2" />
                    <button
                      type="button"
                      onClick={onClickOpenCollectionEditModal}
                      className="dropdown-item"
                    >
                      <i className="fas fa-edit dropdown-item-icon mr-2"></i> {l("Editar tabla%CA019")}
                    </button>
                  </div>
                )
              }

              {
                showPermissions && (
                  <div>
                    <button
                      type="button"
                      onClick={onClickOpenPermissionModal}
                      className="dropdown-item"
                    >
                      <i className="fas fa-user-shield dropdown-item-icon mr-2"></i>
                      {l("Ver permisos%CA152")}
                    </button>
                  </div>
                )}

              {
                !isReadOnly && showManageCollections && (
                  <div>
                    <hr className="my-2" />
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={() => setIsCloneModalShown(true)}
                    >
                      <i className="fas fa-copy dropdown-item-icon mr-2"></i>
                      {l("Duplicar%CA007")}
                    </button>
                  </div>
                )
              }

              {
                !isReadOnly && showManageCollections && (
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={onClickDeleteCollection}>
                    <i className="fas fa-trash dropdown-item-icon mr-2"></i>
                    {l("Eliminar%GA001")}
                  </button>
                )
              }

            </div>
          </>
        }

        {
          showDownloadZip && (
            <button
              type="button"
              className="btn btn-sm btn-lighter-white text-center ml-2"
              onClick={() => onClickDownloadZip("file")}
            >
              <i className="fas fa-download"></i>
            </button>
          )
        }

      </div>

    </div>
  );

}

export default TableControls;